import React, { useEffect, useState } from "react";
import "./filter.scss";
import Arrow from "../../../assets/images/filter-arrow.png";
const FIlter = ({ callback }) => {
  const [state, setstate] = useState("DEFAULT");

  //   Dropdown to sort posts in ascending or descending order depending on title.
  function updatePosts(filter) {
    setstate(filter);
  }
  useEffect(() => {
    callback(state);
  }, [state]);


  return (
    <>
      <div className=" sort-container ">
        <img className="filter-arrow" src={Arrow} alt="Scholar" width="20px" />{" "}
        <select
          defaultValue={"DEFAULT"}
          onChange={(e) => updatePosts(e.target.value)}
        >
          <option value="DEFAULT" disabled>
            Order
          </option>
          <option value="descending">Newest First</option>
          <option value="ascending">Oldest First</option>
        </select>{" "}
      </div>
    </>
  );
};

export default FIlter;
